module.exports = __webpack_public_path__ + "static/media/01_video_thumbnail_mobile.cb1f068d.jpg";